module.exports = __webpack_public_path__ + "static/media/luminary.c5bb7659.png";